import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Api from '@/services/http'
import { AppDispatch } from '@/store'
import * as Types from './types'

export const SL_APPID = 'SL101'

const initialState: Types.StoreState = {
  storeList: [],
  pagination: {
    pageSize: 999,
    pageNum: 1,
    total: 0,
  },
}

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    setStoreList(state, action: PayloadAction<Types.StoreState['storeList']>) {
      return {
        ...state,
        storeList: action.payload,
      }
    },
    setPagination(state, action: PayloadAction<Types.StoreState['pagination']>) {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      }
    },
  },
})

export const { setStoreList, setPagination } = storeSlice.actions

/** 已绑定渠道店铺列表 */
export const queryStoreList = (params?: Types.QueryStoreListType) => async (dispatch: AppDispatch) => {
  const response = await Api.admin.post<Types.ResponseQueryType>('/api/store/list', {
    ...params,
  })

  const { bizCode, data: rstData, bizMessage } = response
  if (bizCode === 'SUCCESS') {
    const list = rstData?.data || []
    dispatch(setStoreList(list))
    dispatch(
      setPagination({
        pageNum: rstData?.pageNum,
        pageSize: rstData?.pageSize,
        total: rstData?.total,
      })
    )

    return list
  }

  return Promise.reject(bizMessage)
}

export default storeSlice.reducer
